/** The booking record's empty states (plan §1.6) on the records core's
 *  `RecordEmptyState`, pointing back to the bookings grid. */
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { RecordEmptyState } from '@/features/records/page/RecordStates';

const BACK = (
  <Button component={RouterLink} to="/bookings" startIcon={<ArrowBackIcon />} size="small">
    Back to bookings
  </Button>
);

export function BookingNotFound({ id }: { id: number | string }) {
  return (
    <RecordEmptyState icon={<SearchOffIcon />} title={`Booking #${id} not found`} action={BACK}>
      No booking has this id — it may have been deleted, or the link carries a booking-system id rather than the
      console’s. Search the bookings grid by its reference instead.
    </RecordEmptyState>
  );
}

export function BookingNoPermission({ id }: { id: number | string }) {
  return (
    <RecordEmptyState icon={<LockOutlinedIcon />} title={`You can’t open booking #${id}`} action={BACK}>
      Your console role does not include this booking. Ask an Ops admin for the bookings permission it needs.
    </RecordEmptyState>
  );
}
